import script from "./FooterFastenaktion.vue?vue&type=script&setup=true&lang=js"
export * from "./FooterFastenaktion.vue?vue&type=script&setup=true&lang=js"

import "./FooterFastenaktion.vue?vue&type=style&index=0&id=52f4419a&lang=scss&scoped=true"
import "./FooterFastenaktion.vue?vue&type=style&index=1&id=52f4419a&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52f4419a"]])

export default __exports__